export enum AssessmentApplicationMode {
  Online = 0,
  Impressa = 1,
  Hibrido = 2,
}
